import {downgradeInjectable} from "@angular/upgrade/static";
import {Router} from '@angular/router';

angular.module('main').factory('ng2Router', downgradeInjectable(Router));
